import React, { useRef } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

interface RevealProps {
    children: React.ReactNode;
    animation?: 'fade-in' | 'slide-up' | 'scale-in' | 'advanced-reveal' | 'flip-in';
    className?: string;
    delay?: number;
    id?: string;
}

const Reveal: React.FC<RevealProps> = ({
    children,
    animation = 'slide-up',
    className = '',
    delay = 0,
    id
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const entry = useIntersectionObserver(ref as React.RefObject<Element>, { freezeOnceVisible: true, threshold: 0.1 });
    const isVisible = !!entry?.isIntersecting;

    return (
        <div
            ref={ref}
            id={id}
            className={`reveal animation-${animation} ${isVisible ? 'reveal--visible' : ''} ${className}`}
            style={{ animationDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
};

export default Reveal;
